import { Typography } from "@bca/ui-library";
import React from "react";

import DetailedCard from "../../Claims/DetailedCard";

interface ExportProps {
  isVisible?: boolean;
  requestDeliveryExportLink: string;
  bookExportDeliveryOnClickHandler?: () => void;
}

const Export: React.FunctionComponent<ExportProps> = ({
  isVisible = false,
  requestDeliveryExportLink,
  bookExportDeliveryOnClickHandler = () => {},
}) => {
  if (isVisible)
    return (
      <DetailedCard
        width="100%"
        icon="location-dot"
        link={requestDeliveryExportLink}
        headline="Export Vehicle"
        label="Request Export"
        ariaLabel="Export"
        iconColor="primary-light-blue"
        hoverBorderEnabled={false}
        additionalOnClickHandler={bookExportDeliveryOnClickHandler}
      >
        <Typography>Export your purchase to the Republic of Ireland</Typography>
      </DetailedCard>
    );
  return null;
};

export default Export;
